module.exports = __webpack_public_path__ + "img/gold50.4c82fedf.png";